import { FC } from 'react';

import styled from 'styled-components';

import { useNavigate } from 'react-router-dom';

import { EUIButtonBaseOpacity } from '@aquariuxfintech/aqx-trader-react-ui/button';
import { ESpacing } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

import { ELoginAs } from '@aqx-core/common/api/auth';
import { AUTHENTICATION_ROUTES } from '@aqx-core/common/constants/router';
import { useLoginForgotPasswordAction } from '@aqx-core/common/hooks/auth/use-login-forgot-password-action';
import { useAuthLoading } from '@aqx-core/common/services/auth';
import { rgba } from '@aqx-core/common/theme';
import { openUrl } from '@aqx-member/web/utils/url/open-url';

interface ILoginForgotPasswordProps {
  selectedTab: ELoginAs | undefined;
}

const LoginForgotPassword: FC<ILoginForgotPasswordProps> = ({ selectedTab }) => {
  const authLoginLoading = useAuthLoading();
  const navigate = useNavigate();

  const { onPress, forgotText } = useLoginForgotPasswordAction({
    selectedTab,
    navigateForgotPasswordCRM: () => navigate(AUTHENTICATION_ROUTES.FORGOT_PASSWORD_CRM),
    navigateForgotPasswordLive: () => navigate(AUTHENTICATION_ROUTES.FORGOT_PASSWORD_LIVE),
    navigateResetPassword: () => navigate(AUTHENTICATION_ROUTES.RESET_PASSWORD),
    openUrlCallback: (url: string) => openUrl(url, '_blank')
  });

  if (!forgotText) {
    return null;
  }

  return (
    <StyledContainer>
      <StyledText as="span" onClick={onPress} $disabled={authLoginLoading}>
        {forgotText}
      </StyledText>
    </StyledContainer>
  );
};

export default LoginForgotPassword;

const StyledContainer = styled.div`
  margin-top: ${ESpacing.REGULAR}px;
  align-self: end;
`;

const StyledText = styled(UIText)<{ $disabled?: boolean }>`
  margin-top: ${ESpacing.XXS}px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  color: ${({ theme, $disabled }) =>
    $disabled ? rgba(theme.themeColors.primary, EUIButtonBaseOpacity.DISABLED) : theme.themeColors.primary};
`;
